export const airlines_selected = [
    {
        "id": "1",
        "name": "Iran Air",
        "iata": "IR",
        "icao": "IRA",
        "callsign": "IRANAIR",
        "commenced": "1961",
        "country": "IRAN",
        "hub": "",
        "image": "airline/IR/image.jpg",
        "logo": "airline/IR/logo.png",
        "icon": "airline/IR/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "2",
        "name": "Mahan Air",
        "iata": "W5",
        "icao": "IRM",
        "callsign": "MAHAN AIR",
        "commenced": "1992",
        "country": "IRAN",
        "hub": "",
        "image": "airline/W5/image.jpg",
        "logo": "airline/W5/logo.png",
        "icon": "airline/W5/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "7",
        "name": "Qeshm Airlines",
        "iata": "QB",
        "icao": "IRQ",
        "callsign": "QESHM AIR",
        "commenced": "1996",
        "country": "IRAN",
        "hub": "",
        "image": "airline/QB/image.jpg",
        "logo": "airline/QB/logo.png",
        "icon": "airline/QB/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "9",
        "name": "Taban Air",
        "iata": "HH",
        "icao": "TBM",
        "callsign": "TABAN AIR",
        "commenced": "2006",
        "country": "IRAN",
        "hub": "",
        "image": "airline/HH/image.jpg",
        "logo": "airline/HH/logo.png",
        "icon": "airline/HH/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },

];

export const airlines = [
    {
        "id": "1",
        "name": "Iran Air",
        "iata": "IR",
        "icao": "IRA",
        "callsign": "IRANAIR",
        "commenced": "1961",
        "country": "IRAN",
        "hub": "",
        "image": "airline/IR/image.jpg",
        "logo": "airline/IR/logo.png",
        "icon": "airline/IR/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "2",
        "name": "Mahan Air",
        "iata": "W5",
        "icao": "IRM",
        "callsign": "MAHAN AIR",
        "commenced": "1992",
        "country": "IRAN",
        "hub": "",
        "image": "airline/W5/image.jpg",
        "logo": "airline/W5/logo.png",
        "icon": "airline/W5/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "3",
        "name": "Iran Aseman Airlines",
        "iata": "EP",
        "icao": "IRC",
        "callsign": "ASEMAN",
        "commenced": "1980",
        "country": "IRAN",
        "hub": "",
        "image": "airline/EP/image.jpg",
        "logo": "airline/EP/logo.png",
        "icon": "airline/EP/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "4",
        "name": "Zagros Airlines",
        "iata": "ZV",
        "icao": "IZG",
        "callsign": "ZAGROS",
        "commenced": "2005",
        "country": "IRAN",
        "hub": "",
        "image": "airline/ZV/image.jpg",
        "logo": "airline/ZV/logo.png",
        "icon": "airline/ZV/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "5",
        "name": "ATA Airlines",
        "iata": "I3",
        "icao": "TBZ",
        "callsign": "ATAAIR",
        "commenced": "2010",
        "country": "IRAN",
        "hub": "",
        "image": "airline/I3/image.jpg",
        "logo": "airline/I3/logo.png",
        "icon": "airline/I3/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "6",
        "name": "Kish Air",
        "iata": "Y9",
        "icao": "IRK",
        "callsign": "KISHAIR",
        "commenced": "1989",
        "country": "IRAN",
        "hub": "",
        "image": "airline/Y9/image.jpg",
        "logo": "airline/Y9/logo.png",
        "icon": "airline/Y9/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "7",
        "name": "Qeshm Airlines",
        "iata": "QB",
        "icao": "IRQ",
        "callsign": "QESHM AIR",
        "commenced": "1996",
        "country": "IRAN",
        "hub": "",
        "image": "airline/QB/image.jpg",
        "logo": "airline/QB/logo.png",
        "icon": "airline/QB/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "8",
        "name": "Meraj Airlines",
        "iata": "JI",
        "icao": "MRJ",
        "callsign": "MERAJ",
        "commenced": "2010",
        "country": "IRAN",
        "hub": "",
        "image": "airline/JI/image.jpg",
        "logo": "airline/JI/logo.png",
        "icon": "airline/JI/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "9",
        "name": "Taban Air",
        "iata": "HH",
        "icao": "TBM",
        "callsign": "TABAN AIR",
        "commenced": "2006",
        "country": "IRAN",
        "hub": "",
        "image": "airline/HH/image.jpg",
        "logo": "airline/HH/logo.png",
        "icon": "airline/HH/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "10",
        "name": "Iran Air Tours",
        "iata": "B9",
        "icao": "IRB",
        "callsign": "AIRTOUR",
        "commenced": "1973",
        "country": "IRAN",
        "hub": "",
        "image": "airline/B9/image.jpg",
        "logo": "airline/B9/logo.png",
        "icon": "airline/B9/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "11",
        "name": "Caspian Airlines",
        "iata": "RV",
        "icao": "CPN",
        "callsign": "CASPIAN",
        "commenced": "1993",
        "country": "IRAN",
        "hub": "",
        "image": "airline/RV/image.jpg",
        "logo": "airline/RV/logo.png",
        "icon": "airline/RV/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "12",
        "name": "Taftan Air",
        "iata": "-",
        "icao": "SBT",
        "callsign": "TAFTAN",
        "commenced": "2004",
        "country": "IRAN",
        "hub": "",
        "image": "airline/SBT/image.jpg",
        "logo": "airline/SBT/logo.png",
        "icon": "airline/SBT/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "13",
        "name": "Atrak Air",
        "iata": "AK",
        "icao": "ATR",
        "callsign": "ATRAK",
        "commenced": "2013",
        "country": "IRAN",
        "hub": "",
        "image": "airline/AK/image.jpg",
        "logo": "airline/AK/logo.png",
        "icon": "airline/AK/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "14",
        "name": "Karun Airlines",
        "iata": "NV",
        "icao": "IRG",
        "callsign": "NAFT",
        "commenced": "1992",
        "country": "IRAN",
        "hub": "",
        "image": "airline/NV/image.jpg",
        "logo": "airline/NV/logo.png",
        "icon": "airline/NV/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    },
    {
        "id": "15",
        "name": "Air Djibouti",
        "iata": "IV",
        "icao": "DJU",
        "callsign": "Djibouti",
        "commenced": "1992",
        "country": "Djibouti",
        "hub": "",
        "image": "airline/IV/image.jpg",
        "logo": "airline/IV/logo.png",
        "icon": "airline/IV/icon.png",
        "is_active": "1",
        "created_at": "13/8/2018 17:42:10",
        "updated_at": ""
    }
];

export const airports = [
    {
        "id": "1",
        "iata": "ABD",
        "country": "IRAN",
        "city": "Abadan",
        "name": "Ayatollah Jami International Airport",
        "alias": "Ayatollah Jami International",
        "is_active": "1",
    },

    {
        "id": "3",
        "iata": "AEU",
        "country": "IRAN",
        "city": "Abu Musa Island",
        "name": "Abu Musa Airport",
        "alias": "Abu Musa Airport",
        "is_active": "1",
    },
    {
        "id": "4",
        "iata": "AWZ",
        "country": "IRAN",
        "city": "Ahvaz",
        "name": "Ahvaz International Airport",
        "alias": "Ahvaz International",
        "is_active": "1",
    },
    {
        "id": "5",
        "iata": "AJK",
        "country": "IRAN",
        "city": "Arak",
        "name": "Arak International Airport",
        "alias": "Arak International",
        "is_active": "1",
    },
    {
        "id": "6",
        "iata": "ADU",
        "country": "IRAN",
        "city": "Ardabil",
        "name": "Ardabil Airport",
        "alias": "Ardabil Airport",
        "is_active": "1",
    },
    {
        "id": "7",
        "iata": "YEH",
        "country": "IRAN",
        "city": "Asalouyeh",
        "name": "Asalouyeh Airport",
        "alias": "Asalouyeh Airport",
        "is_active": "1",
    },
    {
        "id": "8",
        "iata": "PGU",
        "country": "IRAN",
        "city": "Asalouyeh",
        "name": "Persian Gulf Airport (Khalije Fars Airport)",
        "alias": "Persian Gulf Airport",
        "is_active": "1",
    },
    {
        "id": "9",
        "iata": "BBL",
        "country": "IRAN",
        "city": "Babolsar",
        "name": "Babolsar Airport",
        "alias": "Babolsar Airport",
        "is_active": "1",
    },
    {
        "id": "10",
        "iata": "IAQ",
        "country": "IRAN",
        "city": "Bahregan",
        "name": "Bahregan Airport",
        "alias": "Bahregan Airport",
        "is_active": "1",
    },
    {
        "id": "11",
        "iata": "BXR",
        "country": "IRAN",
        "city": "Bam",
        "name": "Bam Airport",
        "alias": "Bam Airport",
        "is_active": "1",
    },
    {
        "id": "12",
        "iata": "BND",
        "country": "IRAN",
        "city": "Bandar Abbas",
        "name": "Bandar Abbas International Airport",
        "alias": "Bandar Abbas International",
        "is_active": "1",
    },
    {
        "id": "13",
        "iata": "HDR",
        "country": "IRAN",
        "city": "Bandar Abbas",
        "name": "Havadarya Airport",
        "alias": "Havadarya",
        "is_active": "1",
    },
    {
        "id": "14",
        "iata": "BDH",
        "country": "IRAN",
        "city": "Bandar Lengeh",
        "name": "Bandar Lengeh Airport",
        "alias": "Bandar Lengeh",
        "is_active": "1",
    },

    {
        "id": "16",
        "iata": "XBJ",
        "country": "IRAN",
        "city": "Birjand",
        "name": "Birjand International Airport",
        "alias": "Birjand International",
        "is_active": "1",
    },
    {
        "id": "17",
        "iata": "BJB",
        "country": "IRAN",
        "city": "Bojnord",
        "name": "Bojnord Airport",
        "alias": "Bojnord",
        "is_active": "1",
    },
    {
        "id": "18",
        "iata": "BUZ",
        "country": "IRAN",
        "city": "Bushehr",
        "name": "Bushehr Airport",
        "alias": "Bushehr",
        "is_active": "1",
    },
    {
        "id": "19",
        "iata": "ZBR",
        "country": "IRAN",
        "city": "Chabahar",
        "name": "Konarak Airport",
        "alias": "Konarak",
        "is_active": "1",
    },
    {
        "id": "21",
        "iata": "DEF",
        "country": "IRAN",
        "city": "Dezful",
        "name": "Dezful Airport",
        "alias": "Dezful",
        "is_active": "1",
    },
    {
        "id": "24",
        "iata": "FAZ",
        "country": "IRAN",
        "city": "Fasa",
        "name": "Fasa Airport",
        "alias": "Fasa",
        "is_active": "1",
    },
    {
        "id": "26",
        "iata": "GCH",
        "country": "IRAN",
        "city": "Gachsaran",
        "name": "Gachsaran Airport",
        "alias": "Gachsaran",
        "is_active": "1",
    },
    {
        "id": "29",
        "iata": "GBT",
        "country": "IRAN",
        "city": "Gorgan",
        "name": "Gorgan Airport",
        "alias": "Gorgan",
        "is_active": "1",
    },
    {
        "id": "30",
        "iata": "HDM",
        "country": "IRAN",
        "city": "Hamadan",
        "name": "Hamadan Airport",
        "alias": "Hamadan",
        "is_active": "1",
    },
    {
        "id": "31",
        "iata": "IIL",
        "country": "IRAN",
        "city": "Ilam",
        "name": "Ilam Airport",
        "alias": "Ilam",
        "is_active": "1",
    },
    {
        "id": "32",
        "iata": "IHR",
        "country": "IRAN",
        "city": "Iranshahr",
        "name": "Iranshahr Airport",
        "alias": "Iranshahr",
        "is_active": "1",
    },
    {
        "id": "33",
        "iata": "IFN",
        "country": "IRAN",
        "city": "Isfahan",
        "name": "Isfahan International Airport (Shahid Beheshti International)",
        "alias": "Shahid Beheshti International",
        "is_active": "1",
    },
    {
        "id": "34",
        "iata": "JAR",
        "country": "IRAN",
        "city": "Jahrom",
        "name": "Jahrom Airport",
        "is_active": "1",
    },
    {
        "id": "35",
        "iata": "JSK",
        "country": "IRAN",
        "city": "Jask",
        "name": "Jask Airport",
        "is_active": "1",
    },
    {
        "id": "36",
        "iata": "JYR",
        "country": "IRAN",
        "city": "Jiroft",
        "name": "Jiroft Airport",
        "is_active": "1",
    },
    {
        "id": "37",
        "iata": "KLM",
        "country": "IRAN",
        "city": "Kalaleh",
        "name": "Kalaleh Airport",
        "is_active": "1",
    },
    {
        "id": "38",
        "iata": "KNR",
        "country": "IRAN",
        "city": "Kangan",
        "name": "Jam Airport",
        "is_active": "1",
    },
    {
        "id": "39",
        "iata": "PYK",
        "country": "IRAN",
        "city": "Karaj",
        "name": "Payam Airport",
        "is_active": "1",
    },
    {
        "id": "40",
        "iata": "KKS",
        "country": "IRAN",
        "city": "Kashan",
        "name": "Kashan Airport",
        "is_active": "1",
    },
    {
        "id": "41",
        "iata": "KER",
        "country": "IRAN",
        "city": "Kerman",
        "name": "Kerman Airport",
        "is_active": "1",
    },
    {
        "id": "42",
        "iata": "KSH",
        "country": "IRAN",
        "city": "Kermanshah",
        "name": "Shahid Ashrafi Esfahani Airport",
        "is_active": "1",
    },
    {
        "id": "43",
        "iata": "KHA",
        "country": "IRAN",
        "city": "Khaneh",
        "name": "Khaneh Airport",
        "is_active": "1",
    },
    {
        "id": "45",
        "iata": "KHK",
        "country": "IRAN",
        "city": "Kharg Island",
        "name": "Kharg Airport",
        "is_active": "1",
    },
    {
        "id": "46",
        "iata": "KHD",
        "country": "IRAN",
        "city": "Khorramabad",
        "name": "Khorramabad Airport",
        "is_active": "1",
    },
    {
        "id": "47",
        "iata": "KHY",
        "country": "IRAN",
        "city": "Khoy",
        "name": "Khoy Airport",
        "is_active": "1",
    },
    {
        "id": "48",
        "iata": "KIH",
        "country": "IRAN",
        "city": "Kish Island",
        "name": "Kish International Airport",
        "is_active": "1",
    },
    {
        "id": "49",
        "iata": "LFM",
        "country": "IRAN",
        "city": "Lamerd",
        "name": "Lamerd Airport",
        "is_active": "1",
    },
    {
        "id": "50",
        "iata": "LRR",
        "country": "IRAN",
        "city": "Larestan",
        "name": "Larestan International Airport",
        "is_active": "1",
    },
    {
        "id": "51",
        "iata": "LVP",
        "country": "IRAN",
        "city": "Lavan Island",
        "name": "Lavan Airport",
        "is_active": "1",
    },
    {
        "id": "54",
        "iata": "MRX",
        "country": "IRAN",
        "city": "Mahshahr",
        "name": "Mahshahr Airport",
        "is_active": "1",
    },
    {
        "id": "56",
        "iata": "ACP",
        "country": "IRAN",
        "city": "Maragheh (Sahand)",
        "name": "Sahand Airport",
        "is_active": "1",
    },
    {
        "id": "57",
        "iata": "MHD",
        "country": "IRAN",
        "city": "Mashhad",
        "name": "Mashhad International Airport (Shahid Hashemi Nejad Airport)",
        "is_active": "1",
    },
    {
        "id": "60",
        "iata": "NSH",
        "country": "IRAN",
        "city": "Noshahr",
        "name": "Noshahr Airport",
        "is_active": "1",
    },
    {
        "id": "61",
        "iata": "PFQ",
        "country": "IRAN",
        "city": "Parsabad",
        "name": "Parsabad-Moghan Airport",
        "is_active": "1",
    },
    {
        "id": "62",
        "iata": "GZW",
        "country": "IRAN",
        "city": "Qazvin (Ghazvin)",
        "name": "Qazvin Airport",
        "is_active": "1",
    },
    {
        "id": "64",
        "iata": "GSM",
        "country": "IRAN",
        "city": "Qeshm Island",
        "name": "Dayrestan Airport",
        "is_active": "1",
    },
    {
        "id": "67",
        "iata": "RJN",
        "country": "IRAN",
        "city": "Rafsanjan",
        "name": "Rafsanjan Airport",
        "is_active": "1",
    },
    {
        "id": "68",
        "iata": "RZR",
        "country": "IRAN",
        "city": "Ramsar / Tonekabon",
        "name": "Ramsar Airport",
        "is_active": "1",
    },
    {
        "id": "69",
        "iata": "RAS",
        "country": "IRAN",
        "city": "Rasht",
        "name": "Rasht Airport",
        "is_active": "1",
    },
    {
        "id": "70",
        "iata": "AFZ",
        "country": "IRAN",
        "city": "Sabzevar",
        "name": "Sabzevar Airport",
        "is_active": "1",
    },
    {
        "id": "71",
        "iata": "SDG",
        "country": "IRAN",
        "city": "Sanandaj",
        "name": "Sanandaj Airport",
        "is_active": "1",
    },
    {
        "id": "72",
        "iata": "CKT",
        "country": "IRAN",
        "city": "Sarakhs",
        "name": "Sarakhs Airport",
        "is_active": "1",
    },

    {
        "id": "74",
        "iata": "SRY",
        "country": "IRAN",
        "city": "Sari",
        "name": "Dasht-e Naz Airport",
        "is_active": "1",
    },
    {
        "id": "80",
        "iata": "CQD",
        "country": "IRAN",
        "city": "Shahrekord",
        "name": "Shahrekord Airport",
        "is_active": "1",
    },
    {
        "id": "81",
        "iata": "RUD",
        "country": "IRAN",
        "city": "Shahrood",
        "name": "Shahrood Airport",
        "is_active": "1",
    },
    {
        "id": "82",
        "iata": "SYZ",
        "country": "IRAN",
        "city": "Shiraz",
        "name": "Shiraz International Airport (Shahid Dastghaib International)",
        "is_active": "1",
    },
    {
        "id": "83",
        "iata": "SYJ",
        "country": "IRAN",
        "city": "Sirjan",
        "name": "Sirjan Airport",
        "is_active": "1",
    },
    {
        "id": "84",
        "iata": "SXI",
        "country": "IRAN",
        "city": "Sirri Island",
        "name": "Sirri Island Airport",
        "is_active": "1",
    },
    {
        "id": "85",
        "iata": "TCX",
        "country": "IRAN",
        "city": "Tabas",
        "name": "Tabas Airport",
        "is_active": "1",
    },
    {
        "id": "86",
        "iata": "TBZ",
        "country": "IRAN",
        "city": "Tabriz",
        "name": "Tabriz International Airport",
        "is_active": "1",
    },
    {
        "id": "88",
        "iata": "IKA",
        "country": "IRAN",
        "city": "Tehran",
        "name": "Imam Khomeini International Airport",
        "is_active": "1",
    },
    {
        "id": "89",
        "iata": "THR",
        "country": "IRAN",
        "city": "Tehran",
        "name": "Mehrabad International Airport",
        "is_active": "1",
    },
    {
        "id": "91",
        "iata": "OMH",
        "country": "IRAN",
        "city": "Urmia",
        "name": "Urmia Airport",
        "is_active": "1",
    },
    {
        "id": "92",
        "iata": "YES",
        "country": "IRAN",
        "city": "Yasuj",
        "name": "Yasuj Airport",
        "is_active": "1",
    },
    {
        "id": "93",
        "iata": "AZD",
        "country": "IRAN",
        "city": "Yazd",
        "name": "Shahid Sadooghi Airport",
        "is_active": "1",
    },
    {
        "id": "94",
        "iata": "ACZ",
        "country": "IRAN",
        "city": "Zabol",
        "name": "Zabol Airport",
        "is_active": "1",
    },
    {
        "id": "95",
        "iata": "ZAH",
        "country": "IRAN",
        "city": "Zahedan",
        "name": "Zahedan Airport",
        "is_active": "1",
    },
    {
        "id": "96",
        "iata": "JWN",
        "country": "IRAN",
        "city": "Zanjan",
        "name": "Zanjan Airport",
        "is_active": "1",
    },
];


// WEBPACK FOOTER //
// ./src/redux/utils/airlines.js